import {combineReducers} from 'redux';
import {reducer as toastrReducer} from 'react-redux-toastr';
import {RedirectCorpChooseReducer, RedirectSignInReducer} from "./common/auth/reducers";
import {CommonToastReducer} from "./common/toast/reducers";
import {CommonImageViewerReducer} from "./common/image/viewer/reducers";
import {AccountUserAvatarViewReducer} from "./common/account/avatar/reducers";
import {AccountCorpLogoViewReducer} from "./common/account/corp/logo/reducers";
import {MainLayoutReducer} from "./common/layouts/main/reducers";
import {ProfileLoadReducer} from "./common/layouts/profile/reducers";
import {TopBarLoadReducer} from "./common/layouts/top/reducers";
import {AccountMemberSelectReducer} from "./common/account/member/select/reducers";
import {ConfirmModalReducer} from "./common/confirm/reducers";
import {HelpMainReducer} from "./help/help/list/reducers";
import {AccountMemberInviteReducer} from "./common/account/member/invite/reducers";

export default combineReducers({
    // ==============================
    // 通用
    // ==============================
    toastr: toastrReducer,
    CommonToastReducer,
    CommonImageViewerReducer,
    RedirectSignInReducer,
    RedirectCorpChooseReducer,
    // 头像
    AccountUserAvatarViewReducer,
    //
    AccountMemberInviteReducer,
    // 企业Logo
    AccountCorpLogoViewReducer,
    // 布局
    MainLayoutReducer, // 主布局
    ProfileLoadReducer, // 个人信息布局
    TopBarLoadReducer, // 头部布局
    // 账号相关
    AccountMemberSelectReducer,
    // ==============================
    // 通用
    // ==============================
    ConfirmModalReducer,
    // ==============================
    // help
    // ==============================
    HelpMainReducer, //
});
